import { createEntityAdapter } from '@reduxjs/toolkit';
import IUser from 'types/superadmin/ISuperAdmin';

const apiUsersAdapter = createEntityAdapter<IUser>({
  selectId: apiUser => apiUser.id,
});

export default apiUsersAdapter;
